import { computed, toRefs } from '@vue/composition-api';
import { useConfigStore } from '../store/config';
import { checkTimeBetween, getServerTime } from '../utils/date-helper';
/** 阻断弹窗hook */
export const useBlockDialog = () => {
  const configStore = useConfigStore();
  const { config } = toRefs(configStore);

  const isInBlockPeriod = computed(() => {
    const { startTime, endTime } = config.value?.commonConfig?.blockDialogConfig || {};
    const { commonConfig: { blockDialogConfig } } = config.value;
    if (!blockDialogConfig || !startTime || !endTime) {
      return false;
    }
    const isInPeriod = checkTimeBetween({
      targetTime: getServerTime(),
      startDate: startTime,
      endDate: endTime,
    });
    return isInPeriod;
  });

  const blockText = computed(() => config.value?.commonConfig?.blockDialogConfig?.text || '');
  return toRefs({ isInBlockPeriod, blockText });
};
